"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttInput = _interopRequireDefault(require("./SttInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      fontFamily: '"Noto Sans"'
    }
  };
});
function InputProtocol(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_SttInput["default"], _extends({
    inputProps: {
      maxLength: 13,
      className: classes.root
    }
  }, props));
}
var _default = InputProtocol;
exports["default"] = _default;